(function() {
  function initGiftOptions() {
    var checkbox = document.getElementById('gift-checkbox');
    var messageField = document.getElementById('gift-message-field');
    var label = document.querySelector('.gift-checkbox-label');

    if (!checkbox || !messageField) return;

    function triggerWiggle() {
      var giftIcon = document.querySelector('.gift-icon-svg');
      if (giftIcon) {
        giftIcon.classList.remove('gift-icon-wiggle');
        void giftIcon.offsetWidth; // Force DOM reflow to replay animation
        giftIcon.classList.add('gift-icon-wiggle');
      }
    }

    function updateState() {
      var isChecked = checkbox.checked;
      messageField.style.display = isChecked ? 'block' : 'none';

      if (label) {
        if (isChecked) {
          label.classList.add('is-checked');
        } else {
          label.classList.remove('is-checked');
        }
      }

      if (!isChecked) {
        var textarea = document.getElementById('gift-message');
        if (textarea) textarea.value = '';
      }
    }

    // Trigger wiggle and update state on toggle
    checkbox.addEventListener('change', function() {
      triggerWiggle();
      updateState();
    });

    // Keyboard accessibility for label (Enter / Space)
    if (label) {
      label.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
          e.preventDefault();
          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    // Initialize state
    updateState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftOptions);
  } else {
    initGiftOptions();
  }

  document.addEventListener('shopify:section:load', initGiftOptions);
})();
